import { render, staticRenderFns } from "./RoleEditPage.vue?vue&type=template&id=2c546138&scoped=true&"
import script from "./RoleEditPage.vue?vue&type=script&lang=ts&"
export * from "./RoleEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./RoleEditPage.vue?vue&type=style&index=0&id=2c546138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c546138",
  null
  
)

export default component.exports